import { graphql, useStaticQuery } from "gatsby";

import type { SuperBannerDataProps } from "@theme/types";

const SUPER_BANNER_QUERY = graphql`
  query SuperBannerQuery {
    allStrapiSite(filter: { Name: { ne: "__DO_NOT_REMOVE" } }) {
      nodes {
        Instance
        superBanner {
          id
          theme
          rotationSpeed
          badgeText
          alignment
          bgColor
          message {
            id
            message
            linkLabel
            icon {
              key
            }
            iconPosition
            link {
              label
              url
              ariaLabel
              newWindow
              customAction
            }
          }
          bgImage {
            image480 {
              cloudinaryMedia {
                gatsbyImageData(layout: FIXED, width: 960)
                width
                height
              }
            }
            image768 {
              cloudinaryMedia {
                gatsbyImageData(layout: FIXED, width: 1536)
                width
                height
              }
            }
            image1024 {
              cloudinaryMedia {
                gatsbyImageData(layout: FIXED, width: 2048)
                width
                height
              }
            }
            image1366 {
              cloudinaryMedia {
                gatsbyImageData(layout: FIXED, width: 2732)
                width
                height
              }
            }
            image2560 {
              cloudinaryMedia {
                gatsbyImageData(layout: FIXED, width: 5120)
                width
                height
              }
            }
          }
          localizations {
            id
            locale
            badgeText
            message {
              message
              linkLabel
            }
          }
        }
      }
    }
  }
`;

export const useBlogSuperBannerData = (): SuperBannerDataProps => {
  const { allStrapiSite } = useStaticQuery(SUPER_BANNER_QUERY);

  return allStrapiSite.nodes.find(
    (site: { Instance: string }) => site.Instance.toUpperCase() === "US",
  )?.superBanner as SuperBannerDataProps;
};
